<a class="link" [routerLink]="['facility', facility.id]" [routerLinkActive]="['active-nav']">
  <div class="name">{{ facility.name }}</div>
  <div class="type">{{ facility.facilityType }}</div>
  <div class="num_systems">
    <span class="number">{{ facility.numSystems }}</span>
    <span class="label">systems added</span>
  </div>
</a>
